export const editorSuggestionsAlertId = 'editor-suggestions-alert';
